import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * Launch Darkly Feature Flag
 * https://app.launchdarkly.com/default/test/features/sellers-frontend-self-service-brand-level-discounts-enabled
 * Please remove from Launchy Darkly when this is removed
 *
 * This feature flag will:
 *
 * - Enable the price reductions sidebar
 * - Move the blanket discounts to the new price reductions page
 * - Enable the self-service brand-level discounts
 */

export const useIsSellersFrontendSelfServiceBrandLevelDiscountsEnabled = () => {
  const flags = useFlags();
  const flag = flags.sellersFrontendSelfServiceBrandLevelDiscountsEnabled;

  if (typeof flag === 'boolean') {
    return flag;
  }

  return null;
};
